import React, {Component} from 'react';
import ModalList from "./ModalList";
import { connect } from 'react-redux';
// import { setSignPrivacyAgreement } from "../../action/publicAction";
import NavigatorMain from '../NavigatorMain.js';
import { hashHistory } from 'react-router';
import { getStorage } from '../../common.js';
import { cleanCache } from "../../action/loginAction.js";
import {protocolCode} from '../../BankCode'

let ua=navigator.userAgent.toLowerCase()
class ModalProtocol extends Component{
	constructor(props){
		super(props);
		this.state = {
			setModalShow: false
		}
	}

	componentDidMount(){

	}

	componentWillUnmount() {
		
	}

	unAgreeFun = () => {
		this.setState({
			setModalShow: true
		});
	}

	agreeFun = async () => {
		// let userInfo=await getStorage('currentUserInfo');
		// this.props.dispatch(setSignPrivacyAgreement(userInfo.mobileNo, (result) => {
		// 	if(result.content) {
		// 		hashHistory.goBack();
		// 		setTimeout(() => {
		// 			if(this.props.location.state && this.props.location.state.callback) {
		// 				this.props.location.state.callback();
		// 				return;
		// 			}
		// 			if(this.props.location.query && this.props.location.query.callback) {
		// 				this.props.location.query.callback();
		// 				return;
		// 			}
		// 		});
		// 	}
		// }, () => {

		// }));
	}

	agreeFunSec = () => {
		this.setState({
			setModalShow: false
		});
	}

	unAgreeFunSec = () => {
		if (ua.indexOf("amcfmapp")>-1) {
            let have='没有关闭方法,1秒提示消失';
            if (ua.indexOf("wkwebview")>-1) {
                if (window.webkit) {
                    have='有window.webkit关闭方法,1秒提示消失';
                    // Toast.info(have, 1,()=>{
                        window.webkit.messageHandlers.amcfm_utils.postMessage({"refreshHome":"intelInvest"});
                        window.webkit.messageHandlers.amcfm_utils.postMessage({"finish":""});
                    // });
                }
            }else{
                if (window.amcfm_utils) {
                have='有window.amcfm_utils关闭方法,1秒提示消失';
                    // Toast.info(have, 1,()=>{
                        window.amcfm_utils.refreshHome('intelInvest');
                        window.amcfm_utils.finish();
                    // });
                }
            }
            
    	}else{
            // hashHistory.push({
            //     pathname: '/',
            //   });
            // let app_index=sessionStorage.getItem('app_index')-0;
            // if (app_index!=null) {
            //     console.log(app_index-window.history.length)
            //     setTimeout(function(){
            //         alert(app_index)
            //         alert(window.history.length)
            //         hashHistory.go(app_index-window.history.length);
            //     },200)
            // }
            hashHistory.go(1-window.historyData.length)
            setTimeout(() => {
            	cleanCache(this.props.dispatch);
            });
    	}
	}

	ProtocolPaper = (name) => {
	    let code=protocolCode[name];
	    console.log(hashHistory)
	    hashHistory.push({
	        pathname:'/WebView',
	        state:{name:name,code:code},
	        query: {code:code}
	    })
	}

	render(){
		return (
			<div style={{flex: 1, backgroundColor: "#fff"}}>
		        <NavigatorMain>
		          <div className="boxHeader">
		            <div>
		              
		            </div>
		            <div>
		              <span>温馨提示</span>
		            </div>
		            <div>
		              
		            </div>
		          </div>
		        </NavigatorMain> 
		        <div style={{position: "absolute", top: ua.indexOf("amcfmapp")>-1 ? 0 : 44, bottom: 40, width: "100%", overflow: "auto"}}>
		        	<div style={{paddingLeft: 13, paddingRight: 13, paddingTop: 15}}>
			        	<div>
			        		<span style={{fontSize: 12, color: "#3a3e47"}}>感谢您使用华夏财富APP！</span>
			        	</div>
			        	<div style={{paddingTop: 10}}>
			        		<span style={{fontSize: 12, color: "#3a3e47", lineHeight: "20px"}}>我们非常重视您的个人信息和隐私保护。为了更好地保障您的个人权益，在使用我们的产品前，请您务必审慎阅读、充分理解<span className='red-t' onClick={()=>{this.ProtocolPaper('华夏财富用户隐私政策')}}>《华夏财富用户隐私政策》</span>各条款，我们会按照上述政策收集、使用和共享您的个人信息，</span>
			        	</div>
			        	<div style={{paddingTop: 10}}>
			        		<span style={{fontSize: 12, color: "#3a3e47"}}>如您同意，请点击“同意”开始接受我们的服务。</span>
			        	</div>
			        </div>
		        </div>
		        <div style={{display: "-webkit-flex", height: 40, WebkitFlexDirection: "row", position: "absolute", bottom: 0, width: "100%"}}>
	        		<div onClick={this.unAgreeFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlex: 1, backgroundColor: "#afb0b2"}}>
	        			<span style={{color: "#fff", fontSize: 15}}>不同意</span>
	        		</div>
	        		<div onClick={this.agreeFun} style={{display: "-webkit-flex", WebkitJustifyContent: "center", WebkitAlignItems: "center", WebkitFlex: 1, backgroundColor: "#FA063A"}}>
	        			<span style={{color: "#fff", fontSize: 15}}>同意</span>
	        		</div>
	        	</div>
	        	<ModalList flag={this.state.setModalShow} title = '温馨提示' content = '华夏财富将严格按照上述政策为您提供服务，如您不同意我们的政策，则无法继续使用我们的产品。' btnLeft = '继续退出' btnRight = '我知道了' btnRightFun = {this.agreeFunSec} btnLeftFun = {this.unAgreeFunSec}/>
			</div>
		);
	}

};

const mapStateToProps = (state, ownProps) => {
  return {
  	
  }
}

export default connect(mapStateToProps)(ModalProtocol);


// WEBPACK FOOTER //
// ./src/components/Modal/ModalProtocol.js